var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44335 0.237145C5.74991 -0.0790489 6.24561 -0.0790489 6.5489 0.237145L11.7701 5.61917C12.0766 5.93537 12.0766 6.44666 11.7701 6.75949C11.4635 7.07232 10.9678 7.07569 10.6645 6.75949L6.00102 1.9493L1.33424 6.76285C1.02769 7.07905 0.531985 7.07905 0.228693 6.76285C-0.0745984 6.44666 -0.0778595 5.93537 0.228693 5.62254L5.44335 0.237145Z",
    fill: "#444650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.16880ef7b4dc8243bab78412a0c02ffb.svg";
export { ForwardRef as ReactComponent };